export enum GlobalActions {
  HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__'
}
